import { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";

const Actions = () => {
  const { language } = useContext(AppContext);
  const title1 = ["Почати", "Passez", "Take "];
  const title2 = ["діяти", "à l'action", "action"];
  const actions = [
    {
      title: [
        "Протестуйте заради миру",
        "Manifestez pour la paix",
        "Protest for peace",
      ],
      description: [
        "Мільйони людей по всьому світу виходять на марші та протести на підтримку України. Це показує українському народу, що світ не байдужий, водночас демонструючи вашим урядам, що ви хочете, щоб ваша країна підтримувала Україну.",
        "Des millions de personnes à travers le monde défilent et manifestent pour soutenir l'Ukraine. Cela montre au peuple ukrainien que le monde ne les abandonne pas, tout en montrant à vos gouvernements que vous voulez que votre pays soutienne l'Ukraine.",
        "Millions of people around the world are marching and protesting in support of Ukraine. It shows the Ukrainian people that the world is not giving up on them, whilst showing your governments that you want your country to supporting Ukraine.",
      ],
      icon: (
        <svg
          fill="#FFFFFF"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 300.3 300.3"
          className="w-full"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <g>
                {" "}
                <path d="M295.047,60.329c-31.864-18.033-70.007-21.645-104.653-9.911c-2.428,0.822-4.816,1.719-7.173,2.673 c0.457-5.465,1.688-10.856,3.692-15.999c1.44-3.695,0.642-7.889-2.055-10.796c-2.699-2.907-6.821-4.02-10.613-2.859 c-30.415,9.293-55.5,31.167-68.823,60.014c-5.2,11.262-8.446,23.056-9.708,35.187l-5.896-5.875 C78.41,101.393,63.257,95.132,47.15,95.132C21.152,95.132,0,116.284,0,142.282c0,5.717,4.633,10.35,10.35,10.35h16.604 c3.375,0,6.515,1.516,8.62,4.169l0.335,0.421c1.281,1.613,2.092,3.644,2.345,5.878c4.958,43.737,31.434,81.466,70.827,100.924 c17.801,8.793,37.398,13.293,57.062,13.293c9.386,0,18.79-1.026,28.02-3.099c28.142-6.322,53.599-22.066,71.684-44.335 c2.922-3.598,3.095-8.7,0.424-12.488c-2.67-3.788-7.535-5.338-11.905-3.796c-22.362,7.895-40.416,7.084-53.312,2.423 c14.795-5.862,27.769-15.74,37.375-28.636c8.815-11.835,13.388-27.099,12.879-42.977c-0.023-0.706-0.033-1.415-0.033-2.126 c0-27.929,16.716-52.8,42.588-63.363c3.671-1.5,6.164-4.966,6.416-8.924C300.532,66.038,298.5,62.283,295.047,60.329z M124.217,92.131c8.147-17.64,21.694-32.079,38.424-41.387c-0.394,4.303-0.427,8.642-0.104,12.971 c-18.995,12.042-34.486,28.902-45.057,49.332C118.867,105.888,121.096,98.891,124.217,92.131z M230.575,142.282 c0,0.93,0.016,1.858,0.045,2.785c0.36,11.221-2.762,21.858-8.792,29.953c-9.399,12.618-23.046,21.435-38.427,24.825 c-2.701,0.596-5.458,1.012-8.43,1.275c-3.866,0.342-7.217,2.819-8.678,6.416c-1.461,3.596-0.785,7.708,1.749,10.649 c10.173,11.808,29.4,22.223,55.53,21.986c-31.04,19.659-70.673,22.407-105.325,5.29c-33.051-16.325-55.267-47.988-59.427-84.694 c-0.689-6.089-3.006-11.768-6.709-16.43l-0.333-0.42c-6.049-7.618-15.097-11.986-24.825-11.986h-4.145 c4.036-9.455,13.427-16.1,24.341-16.1c10.591,0,20.555,4.117,28.057,11.593l7.458,7.432c8.137,8.109,20.092,11.239,31.195,8.174 c8.872-2.448,16.352-8.83,20.518-17.508c12.681-26.398,34.934-46.108,62.658-55.499c22.862-7.744,47.538-7.522,70.042,0.286 C244.403,86.825,230.575,113.287,230.575,142.282z"></path>{" "}
              </g>{" "}
            </g>{" "}
          </g>
        </svg>
      ),
    },
    {
      title: [
        "Надішліть гуманітарну допомогу",
        "Envoyez de l'aide humanitaire",
        "Send humanitarian aid",
      ],
      description: [
        "Терміново потрібно все: від медичного обладнання до дитячого харчування. Багато місцевих організацій співпрацюють зі своїми громадами, щоб відправляти партії в Україну. Щоб дізнатися, яка допомога потрібна та як її відправити в Україну, <a href='https://helpukraine.center/' rel='noreferrer' target='_blank'>натисніть тут</a>.",
        "Des fournitures sont nécessaires de toute urgence, allant du matériel médical à la nourriture pour bébé. De nombreuses organisations locales travaillent avec leurs communautés pour envoyer des lots en Ukraine. Pour obtenir des instructions sur l'aide nécessaire et comment acheminer l'aide vers l'Ukraine, <a href='https://helpukraine.center/' rel='noreferrer' target='_blank'>cliquez ici</a>.",
        "Supplies are needed urgently, everything from medical equipment to baby food. Many local organisations are working with their communities to send batches to Ukraine. For instructions on what aid is needed and how to get the aid to Ukraine <a href='https://helpukraine.center/' rel='noreferrer' target='_blank'>click here</a>.",
      ],
      icon: (
        <svg
          fill="#FFFFFF"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-full"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path d="M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.47a1 1 0 00.99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.84l.58-3.47a2 2 0 00-1.34-2.23z"></path>{" "}
          </g>
        </svg>
      ),
    },
    {
      title: [
        "Приймайте тимчасово українців",
        "Accueillez temporairement des personnes d’Ukraine",
        "Temporarily host Ukrainians",
      ],
      description: [
        "Приблизно 8 мільйонів українців були змушені покинути свою країну, щоб знайти безпеку за кордоном. Якщо ви можете прийняти їх, тоді вам слід звернутися до місцевих організацій, які допоможуть вам вибрати українську родину.",
        "On estime que 8 millions d'Ukrainiens ont été contraints de quitter leur pays pour trouver la sécurité à l'étranger. Si vous êtes en mesure de les héberger, vous devriez contacter des organisations locales qui vous aideront à vous mettre en contact avec une famille ukrainienne.",
        "An estimated 8 million Ukrainians have been forced to leave their country to find safety abroad. If you are able to host them, then you should reach out to local organisations who will help you match you with a Ukrainian family.",
      ],
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="#FFFFFF"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path d="M12.2796 3.71579C12.097 3.66261 11.903 3.66261 11.7203 3.71579C11.6678 3.7311 11.5754 3.7694 11.3789 3.91817C11.1723 4.07463 10.9193 4.29855 10.5251 4.64896L5.28544 9.3064C4.64309 9.87739 4.46099 10.0496 4.33439 10.24C4.21261 10.4232 4.12189 10.6252 4.06588 10.8379C4.00765 11.0591 3.99995 11.3095 3.99995 12.169V17.17C3.99995 18.041 4.00076 18.6331 4.03874 19.0905C4.07573 19.536 4.14275 19.7634 4.22513 19.9219C4.41488 20.2872 4.71272 20.5851 5.07801 20.7748C5.23658 20.8572 5.46397 20.9242 5.90941 20.9612C6.36681 20.9992 6.95893 21 7.82995 21H7.99995V18C7.99995 15.7909 9.79081 14 12 14C14.2091 14 16 15.7909 16 18V21H16.17C17.041 21 17.6331 20.9992 18.0905 20.9612C18.5359 20.9242 18.7633 20.8572 18.9219 20.7748C19.2872 20.5851 19.585 20.2872 19.7748 19.9219C19.8572 19.7634 19.9242 19.536 19.9612 19.0905C19.9991 18.6331 20 18.041 20 17.17V12.169C20 11.3095 19.9923 11.0591 19.934 10.8379C19.878 10.6252 19.7873 10.4232 19.6655 10.24C19.5389 10.0496 19.3568 9.87739 18.7145 9.3064L13.4748 4.64896C13.0806 4.29855 12.8276 4.07463 12.621 3.91817C12.4245 3.7694 12.3321 3.7311 12.2796 3.71579ZM11.1611 1.79556C11.709 1.63602 12.2909 1.63602 12.8388 1.79556C13.2189 1.90627 13.5341 2.10095 13.8282 2.32363C14.1052 2.53335 14.4172 2.81064 14.7764 3.12995L20.0432 7.81159C20.0716 7.83679 20.0995 7.86165 20.1272 7.88619C20.6489 8.34941 21.0429 8.69935 21.3311 9.13277C21.5746 9.49916 21.7561 9.90321 21.8681 10.3287C22.0006 10.832 22.0004 11.359 22 12.0566C22 12.0936 22 12.131 22 12.169V17.212C22 18.0305 22 18.7061 21.9543 19.2561C21.9069 19.8274 21.805 20.3523 21.5496 20.8439C21.1701 21.5745 20.5744 22.1701 19.8439 22.5496C19.3522 22.805 18.8274 22.9069 18.256 22.9543C17.706 23 17.0305 23 16.2119 23H15.805C15.7972 23 15.7894 23 15.7814 23C15.6603 23 15.5157 23.0001 15.3883 22.9895C15.2406 22.9773 15.0292 22.9458 14.8085 22.8311C14.5345 22.6888 14.3111 22.4654 14.1688 22.1915C14.0542 21.9707 14.0227 21.7593 14.0104 21.6116C13.9998 21.4843 13.9999 21.3396 13.9999 21.2185L14 18C14 16.8954 13.1045 16 12 16C10.8954 16 9.99995 16.8954 9.99995 18L9.99996 21.2185C10 21.3396 10.0001 21.4843 9.98949 21.6116C9.97722 21.7593 9.94572 21.9707 9.83107 22.1915C9.68876 22.4654 9.46538 22.6888 9.19142 22.8311C8.9707 22.9458 8.75929 22.9773 8.6116 22.9895C8.48423 23.0001 8.33959 23 8.21847 23C8.21053 23 8.20268 23 8.19495 23H7.78798C6.96944 23 6.29389 23 5.74388 22.9543C5.17253 22.9069 4.64769 22.805 4.15605 22.5496C3.42548 22.1701 2.8298 21.5745 2.4503 20.8439C2.19492 20.3523 2.09305 19.8274 2.0456 19.2561C1.99993 18.7061 1.99994 18.0305 1.99995 17.212L1.99995 12.169C1.99995 12.131 1.99993 12.0936 1.99992 12.0566C1.99955 11.359 1.99928 10.832 2.1318 10.3287C2.24383 9.90321 2.42528 9.49916 2.66884 9.13277C2.95696 8.69935 3.35105 8.34941 3.87272 7.8862C3.90036 7.86165 3.92835 7.83679 3.95671 7.81159L9.22354 3.12996C9.58274 2.81064 9.89467 2.53335 10.1717 2.32363C10.4658 2.10095 10.781 1.90627 11.1611 1.79556Z"></path>{" "}
          </g>
        </svg>
      ),
    },
  ];

  return (
    <>
      <div className="width-container break900:mb-[30px]">
        {/* Section Title */}
        <div className="about-text-header">
          <h1>{title1[language]}</h1>
          <h1>{title2[language]}</h1>
          <span></span>
        </div>
        <div className="pb-[30px] flex flex-wrap gap-6 justify-center items-stretch">
          {actions.map((item, index) => (
            <div
              key={index}
              className="relative text-center grow shrink basis-[300px] break900:basis-[250px] break900:first:top-[30px] break900:last:top-[30px] bg-lightColor g-shadow rounded-lg p-6 flex justify-center items-center"
            >
              <div>
                <div className="get-inv-icon mb-6 bg-lightBlue">
                  {item.icon}
                </div>
                <h6 className="text-xl font-semibold text-darkColor mb-[20px]">
                  {item.title[language]}
                </h6>
                <p
                  className="text-darkColor"
                  dangerouslySetInnerHTML={{
                    __html: item.description[language],
                  }}
                ></p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Actions;
